import RootActionTypes from "./root.types";

export const resetApp = value => ({
    type: RootActionTypes.RESET_REDUX,
    payload: value
});
